import { render, staticRenderFns } from "./VerifyUser.vue?vue&type=template&id=a384f0a6&scoped=true"
import script from "./VerifyUser.vue?vue&type=script&lang=js"
export * from "./VerifyUser.vue?vue&type=script&lang=js"
import style0 from "./VerifyUser.vue?vue&type=style&index=0&id=a384f0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a384f0a6",
  null
  
)

export default component.exports